import { COLORS } from '../../../configs/colors';
import { ActivityLane } from '../../../constants/service-activity.constant';

export interface LaneTokens {
  /** Magnitude-bar fill. Theme path or hex — both resolve through `sx`. */
  fill: string;
  /** Lane label text — must clear 4.5:1 on white, since it carries a label. */
  text: string;
}

export const LANE_TOKENS: Record<ActivityLane, LaneTokens> = {
  // Teal comes from the theme: `accent` is 3.75:1 (fine as a bar fill), while
  // `accentDark` is 5.47:1 and is the one the theme designates for text.
  [ActivityLane.JobFlow]: {
    fill: 'v4.accent',
    text: 'v4.accentDark',
  },
  [ActivityLane.Parts]: {
    fill: COLORS.ActivityLaneParts,
    text: COLORS.ActivityLanePartsText,
  },
  [ActivityLane.Exception]: {
    fill: COLORS.ActivityLaneException,
    text: COLORS.ActivityLaneExceptionText,
  },
};

/** 9px uppercase lane caption. The type scale is where this page gets its
 *  personality — Inter is fixed by the theme. */
export const LANE_LABEL_SX = {
  fontSize: '9px',
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
} as const;

export const STAGE_LABEL_SX = {
  fontSize: '9px',
  fontWeight: 700,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: 'text.secondary',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
} as const;

/** Tabular figures so counts line up across stages — the old table's did not. */
export const STAGE_COUNT_SX = {
  fontSize: '20px',
  fontWeight: 700,
  lineHeight: 1.1,
  fontVariantNumeric: 'tabular-nums',
  color: 'text.primary',
} as const;

export const STAGE_BUTTON_SX = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: '3px',
  flex: 1,
  minWidth: 0,
  px: '8px',
  py: '6px',
  border: 'none',
  borderRadius: 1,
  bgcolor: 'transparent',
  textAlign: 'left',
  font: 'inherit',
  color: 'inherit',
} as const;
